import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  title: string;
  btn: ReactNode;
  lng: string;
  currency: {
    code: string;
    currency: string;
    digits: number;
    number: string;
    updatedAt: string;
    use: boolean;
    world: boolean;
  };
}

const ProfileBox = ({ title, btn, lng, currency }: Props) => {
  const { t } = useTranslation();
  const getMetric = localStorage.getItem('metric');

  return (
    <div className="flex flex-col justify-evenly p-8 border border-primitiveGrey w-full rounded-2xl mb-8 md:m-0 md:w-full">
      <div className="flex items-center mb-6">
        <div className="font-bold text-xl mr-4">{title}</div>
        <div>{btn}</div>
      </div>
      <div className="text-secondaryText mb-2">
        {t('language')}: <span className="text-black">{lng}</span>
      </div>
      <div className="text-secondaryText mb-2">
        {t('currency')}: <span className="text-black">{currency?.code}</span>
      </div>
      <div className="text-secondaryText">
        {t('systemofUnits')}: <span className="text-black">{getMetric}</span>
      </div>
    </div>
  );
};

export default ProfileBox;
